import React, { Fragment } from 'react';
import { render } from 'react-dom';
import moment from 'moment';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';
import Popup from 'react-popup';
import 'react-tippy/dist/tippy.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import 'react-popup/style.css';
import { IntlProvider } from 'react-intl';

import { translationMessages } from './i18n';
import { client } from './client';
import store, { history } from './store';

import './index.css';
import General from './containers/General';
import Profile from './containers/Profile';
import Search from './containers/Search';
import Admin from './containers/Admin';
import Artist from './containers/Artist';

import esLocale from './moment.es';
import ScrollToTop from './containers/Others/ScrollToTop';
import RefreshUser from './containers/Others/RefreshUser';
import GetRole from './utils/GetRole';
import { ADMIN_ROLE, ARTIST_ROLE, THEATER_ADMIN_ROLE } from './constants';

const target = document.querySelector('#root');
const lang = navigator.language.split('-')[0];
moment.locale('es', esLocale);

const role = GetRole();
if (role !== ADMIN_ROLE && role !== THEATER_ADMIN_ROLE && role !== ARTIST_ROLE) {
  localStorage.removeItem('escenaToken');
  localStorage.removeItem('escenaRole');
  localStorage.removeItem('escenaTheater');
  localStorage.removeItem('escenaStats');
  localStorage.removeItem('escenaPlan');
}

render(
  <Fragment>
    <Helmet>
      <title>Escena Marketplace</title>
    </Helmet>
    <Popup />
    <IntlProvider locale={lang} messages={translationMessages[lang]}>
      <ApolloProvider client={client}>
        <Provider store={store}>
          <RefreshUser>
            <ConnectedRouter history={history}>
              <ScrollToTop>
                <Switch>
                  <Route path="/me" component={Profile} />
                  <Route path="/admin" component={Admin} />
                  <Route path="/search" component={Search} />
                  <Route path="/artist-profile" component={Artist} />
                  <Route path="/" component={General} />
                </Switch>
              </ScrollToTop>
            </ConnectedRouter>
          </RefreshUser>
        </Provider>
      </ApolloProvider>
    </IntlProvider>
  </Fragment>,
  target,
);



// WEBPACK FOOTER //
// ./src/index.js